import React from 'react';

export default function CuteEmoji({ mood, className = "w-12 h-12" }) {
  if (mood === 'happy') {
    return (
      <svg viewBox="0 0 100 100" className={className}>
        <circle cx="50" cy="50" r="48" fill="#10b981" />
        <circle cx="28" cy="40" r="6" fill="#064e3b" />
        <circle cx="72" cy="40" r="6" fill="#064e3b" />
        {/* Rosy cheeks */}
        <ellipse cx="20" cy="55" rx="7" ry="4" fill="#34d399" opacity="0.6" />
        <ellipse cx="80" cy="55" rx="7" ry="4" fill="#34d399" opacity="0.6" />
        {/* Big smile */}
        <path d="M 30 60 Q 50 85 70 60" fill="none" stroke="#064e3b" strokeWidth="6" strokeLinecap="round" />
      </svg>
    );
  }
  
  if (mood === 'neutral') {
    return (
      <svg viewBox="0 0 100 100" className={className}>
        <circle cx="50" cy="50" r="48" fill="#eab308" />
        {/* Eyes looking sideways/flat */}
        <path d="M 22 40 L 34 40" stroke="#713f12" strokeWidth="6" strokeLinecap="round" />
        <path d="M 66 40 L 78 40" stroke="#713f12" strokeWidth="6" strokeLinecap="round" />
        {/* Flat mouth */}
        <path d="M 35 65 L 65 65" stroke="#713f12" strokeWidth="6" strokeLinecap="round" />
      </svg>
    );
  }

  if (mood === 'angry') {
    return (
      <svg viewBox="0 0 100 100" className={className}>
        <circle cx="50" cy="50" r="48" fill="#f43f5e" />
        {/* Angry eyebrows */}
        <path d="M 18 30 L 38 42" stroke="#881337" strokeWidth="6" strokeLinecap="round" />
        <path d="M 82 30 L 62 42" stroke="#881337" strokeWidth="6" strokeLinecap="round" />
        {/* Eyes */}
        <circle cx="32" cy="48" r="5" fill="#881337" />
        <circle cx="68" cy="48" r="5" fill="#881337" />
        {/* Frown */}
        <path d="M 35 75 Q 50 60 65 75" fill="none" stroke="#881337" strokeWidth="6" strokeLinecap="round" />
      </svg>
    );
  }

  // Pasif: 2+ bulan ga PO — sleepy/merenung
  if (mood === 'pasif') {
    return (
      <svg viewBox="0 0 100 100" className={className}>
        <circle cx="50" cy="50" r="48" fill="#94a3b8" />
        {/* Sleepy eyes */}
        <path d="M 22 45 Q 28 52 34 45" fill="none" stroke="#334155" strokeWidth="5" strokeLinecap="round" />
        <path d="M 66 45 Q 72 52 78 45" fill="none" stroke="#334155" strokeWidth="5" strokeLinecap="round" />
        {/* Little snoot/mouth */}
        <circle cx="50" cy="65" r="4" fill="#334155" />
        {/* Zzz */}
        <path d="M 70 20 L 85 20 L 70 35 L 85 35" fill="none" stroke="#cbd5e1" strokeWidth="4" strokeLinejoin="round" strokeLinecap="round" />
      </svg>
    );
  }

  // Inactive: 7+ bulan ga PO — ghost/totally off
  if (mood === 'inactive') {
    return (
      <svg viewBox="0 0 100 100" className={className}>
        <circle cx="50" cy="50" r="48" fill="#cbd5e1" />
        {/* X eyes (dead) */}
        <path d="M 24 34 L 36 46" stroke="#64748b" strokeWidth="5" strokeLinecap="round" />
        <path d="M 36 34 L 24 46" stroke="#64748b" strokeWidth="5" strokeLinecap="round" />
        <path d="M 64 34 L 76 46" stroke="#64748b" strokeWidth="5" strokeLinecap="round" />
        <path d="M 76 34 L 64 46" stroke="#64748b" strokeWidth="5" strokeLinecap="round" />
        {/* Wavy mouth */}
        <path d="M 32 68 Q 41 60 50 68 Q 59 76 68 68" fill="none" stroke="#64748b" strokeWidth="4" strokeLinecap="round" />
        {/* Ghost sweat drop */}
        <ellipse cx="82" cy="28" rx="4" ry="6" fill="#93c5fd" opacity="0.7" />
      </svg>
    );
  }

  // Default
  return (
    <svg viewBox="0 0 100 100" className={className}>
      <circle cx="50" cy="50" r="48" fill="#e2e8f0" />
      <circle cx="30" cy="40" r="5" fill="#64748b" />
      <circle cx="70" cy="40" r="5" fill="#64748b" />
      <path d="M 40 60 Q 50 70 60 60" fill="none" stroke="#64748b" strokeWidth="5" strokeLinecap="round" />
    </svg>
  );
}
